<div class="info-container">
  @if (!loadingVehiculo) {
    <!-- Resumen fijo: lo que se mira de un vistazo. La identidad (patente,
         tipo, cliente, estado operativo) está en el encabezado. -->
    @let r = resumen;
    <app-dt-card>
      <app-dt-datos destacado>
        <app-dt-dato etiqueta="Conexión" ocultarVacio>
          <app-dt-estado
            [tono]="r.conexion.tono"
            [etiqueta]="r.conexion.etiqueta"
          />
        </app-dt-dato>
        <app-dt-dato
          etiqueta="Último reporte"
          [valor]="r.hace ? 'hace ' + r.hace : null"
        >
          @if (r.fecha) {
            <span class="dt-muted fecha">{{ r.fecha }}</span>
          }
        </app-dt-dato>
        <app-dt-dato etiqueta="Movimiento" ocultarVacio>
          @if (r.movimiento; as m) {
            <app-dt-estado [tono]="m.tono" [etiqueta]="m.etiqueta" />
            @if (r.viaje) {
              <span class="dt-muted fecha">{{ r.viaje }}</span>
            }
          } @else {
            <span class="dt-vacio">Sin información</span>
          }
        </app-dt-dato>
        <app-dt-dato etiqueta="Conductor" [valor]="r.conductor" />
      </app-dt-datos>
    </app-dt-card>

    <div class="cuerpo" [class.sin-historial]="!historialConDatos">
      <!-- Grilla de tarjetas en orden fijo. El mapa es una tarjeta más: arriba
           a la derecha, del alto de las dos primeras. -->
      <div class="info-tables-grid">
        @for (tarjeta of tarjetas; track tarjeta.id) {
          <div
            class="tarjeta-item"
            [class.ancha]="tarjeta.ancha"
            [class.tarjeta-mapa]="tarjeta.id === 'mapa'"
          >
            @switch (tarjeta.id) {
              @case ('mapa') {
                <div class="mapa" #tarjetaMapa>
                  <app-map-card
                    [height]="
                      pantallaAncha() && altoMapa()
                        ? altoMapa() + 'px'
                        : '320px'
                    "
                    [config]="mapCardConfig"
                    [loading]="loadingMap()"
                  ></app-map-card>
                </div>
              }
              @case ('vehiculo') {
                <app-dt-card titulo="Vehículo" icono="directions_car">
                  <ng-container
                    *ngTemplateOutlet="
                      datos;
                      context: { $implicit: filasVehiculo }
                    "
                  ></ng-container>
                </app-dt-card>
              }
              @case ('tracker') {
                <app-dt-card titulo="Tracker y comunicación" icono="gps_fixed">
                  <ng-container
                    *ngTemplateOutlet="
                      datos;
                      context: { $implicit: filasTracker }
                    "
                  ></ng-container>
                </app-dt-card>
              }
              @case ('dashcam') {
                <app-dt-card titulo="Dashcam" icono="video_camera_front">
                  @if (activo?.idDashcam && dashcam) {
                    <ng-container
                      *ngTemplateOutlet="
                        datos;
                        context: { $implicit: filasDashcam }
                      "
                    ></ng-container>
                  } @else if (activo?.idDashcam && !dashcamCargada) {
                    <span class="dt-muted">Cargando…</span>
                  } @else if (activo?.idDashcam) {
                    <!-- Asignada, pero no se pudo leer (sin permiso para ver
                         dashcams o ya no existe) -->
                    <span class="no-info">Sin datos de la dashcam</span>
                  } @else {
                    <span class="no-info">Sin dashcam asignada</span>
                  }
                </app-dt-card>
              }
              @case ('viaje') {
                <app-dt-card titulo="Viaje en curso" icono="route">
                  @if (loadingTrackerStatus()) {
                    <span class="dt-muted">Cargando…</span>
                  } @else if (filasViaje.length) {
                    <ng-container
                      *ngTemplateOutlet="
                        datos;
                        context: { $implicit: filasViaje }
                      "
                    ></ng-container>
                  } @else {
                    <span class="dt-muted">Sin viaje en curso</span>
                  }
                </app-dt-card>
              }
              @case ('chofer') {
                <app-dt-card titulo="Conductor" icono="account_box">
                  <div class="chofer">
                    @if (chofer?.datosPersonales?.foto) {
                      <img
                        [src]="chofer.datosPersonales.foto"
                        alt="Foto del conductor"
                        class="chofer-foto irx-clickeable"
                        role="button"
                        tabindex="0"
                        (click)="showChoferViewer = true"
                        (keydown.enter)="showChoferViewer = true"
                        title="Ver foto completa"
                      />
                      <app-image-viewer
                        [imageUrl]="chofer.datosPersonales.foto"
                        [isVisible]="showChoferViewer"
                        [altText]="chofer.datosPersonales?.nombre"
                        (closeViewer)="showChoferViewer = false"
                      ></app-image-viewer>
                    } @else {
                      <div class="chofer-foto vacia">
                        <mat-icon>person</mat-icon>
                      </div>
                    }
                    <ng-container
                      *ngTemplateOutlet="
                        datos;
                        context: { $implicit: filasChofer }
                      "
                    ></ng-container>
                  </div>
                </app-dt-card>
              }
              @case ('combustible') {
                <app-dt-card titulo="Combustible" icono="local_gas_station">
                  <ng-container
                    *ngTemplateOutlet="
                      datos;
                      context: { $implicit: filasCombustible }
                    "
                  ></ng-container>
                </app-dt-card>
              }
              @case ('temperatura') {
                <app-dt-card titulo="Temperatura de carga" icono="thermostat">
                  <app-dt-datos>
                    <app-dt-dato
                      etiqueta="Temperatura actual"
                      [valor]="statCardTemperatura?.value"
                    />
                  </app-dt-datos>
                  @if (chartCardConfigTemperatura) {
                    <app-chart-card
                      class="grafico"
                      [config]="sinTitulo(chartCardConfigTemperatura)"
                    ></app-chart-card>
                  }
                </app-dt-card>
              }
              @case ('recorrido') {
                <app-dt-card titulo="Recorrido" icono="alt_route">
                  <app-dt-datos>
                    <app-dt-dato
                      etiqueta="Nombre"
                      [valor]="activo?.vehiculo?.recorrido?.nombre"
                    />
                    <app-dt-dato
                      etiqueta="Color"
                      [valor]="activo?.vehiculo?.recorrido?.color"
                      mono
                    >
                      @if (activo?.vehiculo?.recorrido?.color; as color) {
                        <span
                          class="muestra-color"
                          [style.background]="color"
                        ></span>
                      }
                    </app-dt-dato>
                  </app-dt-datos>
                </app-dt-card>
              }
              @case ('obd') {
                <app-dt-card
                  titulo="Telemetría del vehículo"
                  icono="settings_input_component"
                >
                  @if (fechaObd) {
                    <span class="dt-muted subtitulo">
                      Lectura del {{ fechaObd | date: 'dd/MM/yyyy HH:mm' }}
                    </span>
                  }
                  <ng-container
                    *ngTemplateOutlet="datos; context: { $implicit: filasObd }"
                  ></ng-container>
                </app-dt-card>
              }
              @case ('nivelCombChart') {
                <app-dt-card
                  titulo="Historial de nivel de combustible"
                  icono="local_gas_station"
                >
                  <irx-segmentado
                    class="periodo"
                    tamano="compacto"
                    [value]="periodoNivelCombustible"
                    (change)="togglePeriodoNivelCombustible($event.value)"
                  >
                    <irx-segmento [value]="7">7 días</irx-segmento>
                    <irx-segmento [value]="30">30 días</irx-segmento>
                  </irx-segmentado>
                  <app-chart-card
                    class="grafico"
                    [config]="sinTitulo(chartCardConfigNivelCombustible)"
                  ></app-chart-card>
                </app-dt-card>
              }
              @case ('consumoChart') {
                <app-dt-card
                  titulo="Consumo de combustible (últimos 3 meses)"
                  icono="bar_chart"
                >
                  <app-chart-card
                    class="grafico"
                    [config]="sinTitulo(chartCardConfigConsumoCombustible)"
                  ></app-chart-card>
                </app-dt-card>
              }
              @case ('informeCombustible') {
                <app-dt-card
                  titulo="Informes de combustible"
                  icono="local_gas_station"
                >
                  <app-informe-combustible
                    [idActivo]="vehiculo?._id"
                  ></app-informe-combustible>
                </app-dt-card>
              }
              @case ('documentacion') {
                <app-dt-card titulo="Documentación de alta" icono="image">
                  <app-carrusel [imagenes]="activo?.imagenes"></app-carrusel>
                </app-dt-card>
              }
            }
          </div>
        }
      </div>

      <aside class="detalles-historial">
        <app-historial-vehiculo
          [idActivo]="vehiculo?._id"
          [odometroKm]="odometroHistorialKm"
          [odometroCalculado]="odometroHistorialCalculado"
          (tieneDatos)="onHistorialDatos($event)"
        ></app-historial-vehiculo>
      </aside>
    </div>
  } @else {
    <app-detalle-esqueleto soloCuerpo></app-detalle-esqueleto>
  }
</div>

<!-- Lista de datos de una tarjeta -->
<ng-template #datos let-filas>
  <app-dt-datos>
    @for (f of filas; track f.etiqueta) {
      <app-dt-dato
        [etiqueta]="f.etiqueta"
        [valor]="f.valor"
        [mono]="!!f.mono"
        [copiable]="!!f.copiable"
      >
        @if (f.accion; as a) {
          <button
            irxBotonIcono
            tamano="mini"
            class="dt-icono"
            [disabled]="a.disabled"
            (click)="a.click()"
            [tooltip]="a.tooltip"
          >
            <mat-icon>{{ a.icono }}</mat-icon>
          </button>
        }
      </app-dt-dato>
    }
  </app-dt-datos>
</ng-template>
